import AsyncSelect from 'react-select/async';
import BotApi from 'api/bot';

const BotSelect = props => {
  const loadOptions = (input_value, callback) => {
    BotApi.fetch().then(data => {
      const options = data.map(item => {
        return {
          value: item.id,
          label: item.name,
          ...item,
        };
      });

      callback(options.filter(item => item.name.toLowerCase().includes(input_value.toLowerCase())));
    });
  };

  const customStyles = {
    control: provided => ({
      ...provided,
      padding: 8,
    }),
  };

  return (
    <AsyncSelect
      getOptionLabel={option => (
        <>
          <b>{option.label}</b>
          <br />
          <small>{option.description}</small>
        </>
      )}
      styles={customStyles}
      placeholder="Selecione um robô"
      classNamePrefix="select"
      cacheOptions
      defaultOptions
      loadOptions={loadOptions}
      {...props}
    />
  );
};
export default BotSelect;
